export default "__VITE_ASSET__cd76fba5__"